var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCnhFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7178 8.95801L18.7178 8.95801",
    stroke: "#757893",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7178 11.958L18.7178 11.958",
    stroke: "#757893",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2178 15.958L15.2178 15.958",
    stroke: "#757893",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7178 15.958H17.7178",
    stroke: "#757893",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08009 12.3232C8.65895 12.3232 9.21411 12.0933 9.62343 11.684C10.0327 11.2746 10.2627 10.7195 10.2627 10.1406C10.2627 9.56176 10.0327 9.0066 9.62343 8.59728C9.21411 8.18796 8.65895 7.95801 8.08009 7.95801C7.50122 7.95801 6.94607 8.18796 6.53675 8.59728C6.12743 9.0066 5.89748 9.56176 5.89748 10.1406C5.89748 10.7195 6.12743 11.2746 6.53675 11.684C6.94607 12.0933 7.50122 12.3232 8.08009 12.3232ZM11.7178 16.6377C11.717 16.4587 11.4357 15.4513 10.9424 14.958C10.468 14.4837 9.74542 13.958 8.08009 13.958C6.41403 13.958 5.41676 14.4837 4.9424 14.958C4.44913 15.4513 4.44386 16.4587 4.4424 16.6377H11.7178Z",
    stroke: "#757893",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71777 7.95801C1.71777 6.30115 3.06092 4.95801 4.71777 4.95801H19.2178C20.8746 4.95801 22.2178 6.30115 22.2178 7.95801V16.958C22.2178 18.6149 20.8746 19.958 19.2178 19.958H4.71777C3.06092 19.958 1.71777 18.6149 1.71777 16.958V7.95801Z",
    stroke: "#757893",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnhFront);
export default __webpack_public_path__ + "static/media/cnh-front.7787ab3642de599f92ddd457f6fa4b86.svg";
export { ForwardRef as ReactComponent };